import { css } from "@emotion/react"

type Props = {
  children: React.ReactNode
}

const MyPageTheme = ({ children }: Props) => {
  return <div css={myPageTheme.text}>{children}</div>
}

const myPageTheme = {
  text: css`
    font-size: 14px;
    line-height: 1;
    color: #4d4d4d;
  `,
}

export default MyPageTheme
